import React from 'react';

const AnalysisPlaceholder = () => {

    return (
        <div role="status" className="w-full animate-pulse px-4">
            <div className="h-6 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-4"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
            </div>
            <div className="h-6 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-4"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
            </div>
            <div className="h-6 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
            <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-4"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
                <div className="h-40 bg-gray-200 rounded-lg dark:bg-gray-700"></div>
            </div>
            <span className="sr-only">Loading...</span>
        </div>
    );
};

export default AnalysisPlaceholder;